export default '__luda_guid'